'use client';

import React from 'react';

interface LoadingSpinnerProps {
    size?: 'small' | 'medium' | 'large';
    color?: string;
    text?: string;
}

const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
                                                           size = 'medium',
                                                           color = '#1A4D4F',
                                                           text = 'Laddar...'
                                                       }) => {
    // Size mapping
    const sizeMap = {
        small: {
            spinner: 'w-6 h-6',
            container: 'gap-2',
            text: 'text-sm'
        },
        medium: {
            spinner: 'w-10 h-10',
            container: 'gap-3',
            text: 'text-base'
        },
        large: {
            spinner: 'w-14 h-14',
            container: 'gap-4',
            text: 'text-lg'
        }
    };

    const selectedSize = sizeMap[size];

    return (
        <div className="flex flex-col items-center justify-center min-h-[200px]">
            <div className={`flex flex-col items-center ${selectedSize.container}`}>
                <div className={`${selectedSize.spinner} border-4 border-t-transparent rounded-full animate-spin`}
                     style={{ borderColor: `transparent currentColor currentColor currentColor`, color }}>
                </div>
                {text && (
                    <p className={`${selectedSize.text} font-medium`} style={{ color }}>
                        {text}
                    </p>
                )}
            </div>
        </div>
    );
};

export default LoadingSpinner;